// extracted by mini-css-extract-plugin
module.exports = {"page":"page-module--page--3vX9p","page__main":"page-module--page__main--1DHea"};